// extracted by mini-css-extract-plugin
export default {"sectionHeader":"LaunchPadList_sectionHeader__wqS9t","swiperContainer":"LaunchPadList_swiperContainer__HM8Ce"};